import { useMemo } from "react";
import { useGoalsExploreContext } from "src/contexts/goalsExploreContext";
import getObjectiveProgress from "src/commonComponents/ObjectiveProfileHeader/utils/getObjectiveProgress";
import getObjectiveChildrenCount from "../utils/getObjectiveChildrenCount";
import getLinkedTeamsCount from "../utils/getLinkedTeamsCount";
import getObjectiveTypeBadge from "../utils/getObjectiveTypeBadge";
import getObjectiveStatusBadge from "../utils/getObjectiveStatusBadge";

const configMap = {
  badgeConfig: {
    type: getObjectiveTypeBadge,
    status: getObjectiveStatusBadge,
  },
  statsConfig: {
    childCount: getObjectiveChildrenCount,
    teamsCount: getLinkedTeamsCount,
  },
  progressConfig: {
    progress: getObjectiveProgress,
  },
};

const buildConfig = (builders, objective, rawObjectives, associatedTeams) => {
  const items = Object.values(builders)
    .map((builder) => builder(objective, rawObjectives, associatedTeams))
    .filter(Boolean);

  return items.length > 0 ? items : null;
};

const useObjectiveProfileConfig = (objective) => {
  const { rawObjectives, associatedTeams } = useGoalsExploreContext();

  const { badgeConfig, statsConfig, progress } = useMemo(() => {
    if (!objective?.id) {
      return { badgeConfig: null, statsConfig: null, progress: null };
    }

    return {
      badgeConfig: buildConfig(
        configMap.badgeConfig,
        objective,
        rawObjectives,
        associatedTeams
      ),
      statsConfig: buildConfig(
        configMap.statsConfig,
        objective,
        rawObjectives,
        associatedTeams
      ),
      progress: getObjectiveProgress(objective),
    };
  }, [objective, rawObjectives, associatedTeams]);

  return { badgeConfig, statsConfig, progress };
};

export default useObjectiveProfileConfig;
